module.exports = __webpack_public_path__ + "static/media/IMG_4284.864bbdbb.PNG";